import { render } from "./ProductType.vue?vue&type=template&id=69012be8&scoped=true"
import script from "./ProductType.vue?vue&type=script&lang=js"
export * from "./ProductType.vue?vue&type=script&lang=js"

import "./ProductType.vue?vue&type=style&index=0&id=69012be8&scoped=true&lang=css"

import exportComponent from "D:\\laragon\\www\\subeasy\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-69012be8"]])

export default __exports__